export default function _identity(x) {
  return x;
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_identity.js
// module id = 316
// module chunks = 1